
import stringMixin from './stringMixin';

export default {
  name: 'XhInput', // 新建 date
  components: {},
  mixins: [stringMixin],
  props: {},
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  mounted: function mounted() {},

  methods: {}
};